import React from 'react';
import './scss/styles.scss';
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {

    window.location.href = 'https://florida-man-base.webnode.page/'
    
    return (
      <>
          
      </>
    );
}

export default App;
